// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

export var breakpoint = {
  xs: {
    max: 575
  },
  sm: {
    min: 576,
    max: 767
  },
  md: {
    min: 768,
    max: 991
  },
  lg: {
    min: 992,
    max: 1199
  },
  xl: {
    min: 1200
  }
};
export var color = {
  light: {
    foreground: {
      "default": '#1a1a1a',
      medium: '#3d3d3d',
      light: '#666666',
      disabled: '#a3a3a3'
    },
    background: {
      "default": '#fafafa',
      medium: '#f0f0f0',
      disabled: '#e0e0e0',
      container: {
        "default": '#ffffff',
        hover: '#f5f5f5',
        active: '#f0f0f0'
      }
    },
    stroke: {
      decorative: {
        "default": '#e0e0e0',
        hover: '#c2c2c2',
        active: '#a3a3a3'
      },
      informative: {
        "default": '#858585',
        hover: '#666666',
        active: '#525252'
      }
    },
    primary: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#024ad8',
        hover: '#0036c4',
        active: '#001cb0'
      },
      background: {
        "default": '#e4eefa',
        hover: '#c9e0fc',
        active: '#b2d2ff'
      }
    },
    neutral: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#666666',
        hover: '#525252',
        active: '#3d3d3d'
      },
      background: {
        "default": '#f5f5f5',
        hover: 'rgba(163,163,163,0.1)',
        active: 'rgba(163,163,163,0.2)'
      }
    },
    positive: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#007d48',
        hover: '#006c3e',
        active: '#005a35'
      },
      background: {
        "default": '#defff1',
        hover: '#ccffe8',
        active: '#a3ffd6'
      }
    },
    caution: {
      foreground: {
        "default": '#5c4e00',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#ffe137',
        hover: '#f9d300',
        active: '#e5c300'
      },
      background: {
        "default": '#f7f2cb',
        hover: '#fff29e',
        active: '#ffe970'
      }
    },
    warning: {
      foreground: {
        "default": '#1a1a1a',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#ff8900',
        hover: '#e07200',
        active: '#b2600c'
      },
      background: {
        "default": '#ffedde',
        hover: '#ffdbb2',
        active: '#ffc98c'
      }
    },
    negative: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#cc2c00',
        hover: '#9f2301',
        active: '#802208'
      },
      background: {
        "default": '#faeceb',
        hover: '#ffdbd9',
        active: '#ffc1bd'
      }
    },
    help: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#187585',
        hover: '#176673',
        active: '#16555f'
      },
      background: {
        "default": '#d7f4f7',
        hover: '#d4fbff',
        active: '#bcf7ff'
      }
    },
    accent: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#000000',
        hover: '#212121',
        active: '#3d3d3d'
      },
      background: {
        "default": '#fafafa',
        hover: '#f0f0f0',
        active: '#e0e0e0'
      }
    },
    spotlight: {
      foreground: {
        "default": '#1a1a1a',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#ffffff',
        hover: 'rgba(255,255,255,0.8)',
        active: 'rgba(255,255,255,0.6)'
      },
      background: {
        "default": '#1a1a1a',
        hover: 'rgba(255,255,255,0.1)',
        active: 'rgba(255,255,255,0.2)'
      }
    },
    effects: {
      glasswall: 'rgba(26,26,26,0.5)',
      dropShadow: 'rgba(26,26,26,0.2)',
      highlight: {
        "default": 'rgba(84,146,255,0.1)',
        hover: 'rgba(111,165,255,0.3)',
        active: 'rgba(143,186,255,0.6)'
      }
    },
    focus: {
      "default": '#001cb0',
      inverse: '#ffffff'
    }
  },
  dark: {
    foreground: {
      "default": '#ffffff',
      medium: '#e0e0e0',
      light: '#a3a3a3',
      disabled: '#666666'
    },
    background: {
      "default": '#1a1a1a',
      medium: '#292929',
      disabled: '#3d3d3d',
      container: {
        "default": '#212121',
        hover: '#292929',
        active: '#3d3d3d'
      }
    },
    stroke: {
      decorative: {
        "default": '#525252',
        hover: '#666666',
        active: '#858585'
      },
      informative: {
        "default": '#858585',
        hover: '#a3a3a3',
        active: '#c2c2c2'
      }
    },
    primary: {
      foreground: {
        "default": '#1a1a1a',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#5492ff',
        hover: '#6fa5ff',
        active: '#8fbaff'
      },
      background: {
        "default": '#001070',
        hover: '#000083',
        active: '#0000a2'
      }
    },
    neutral: {
      foreground: {
        "default": '#1a1a1a',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#a3a3a3',
        hover: '#c2c2c2',
        active: '#e0e0e0'
      },
      background: {
        "default": '#292929',
        hover: 'rgba(133,133,133,0.1)',
        active: 'rgba(133,133,133,0.2)'
      }
    },
    positive: {
      foreground: {
        "default": '#1a1a1a',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#00d072',
        hover: '#4ef5ab',
        active: '#78ffc2'
      },
      background: {
        "default": '#093021',
        hover: '#07412a',
        active: '#034c2e'
      }
    },
    caution: {
      foreground: {
        "default": '#1a1a1a',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#ffe137',
        hover: '#ffe970',
        active: '#fff29e'
      },
      background: {
        "default": '#302900',
        hover: '#413700',
        active: '#544700'
      }
    },
    warning: {
      foreground: {
        "default": '#1a1a1a',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#ff8900',
        hover: '#ffa238',
        active: '#ffb866'
      },
      background: {
        "default": '#382514',
        hover: '#4a3016',
        active: '#5c3a19'
      }
    },
    negative: {
      foreground: {
        "default": '#1a1a1a',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#ff6a4d',
        hover: '#ff8373',
        active: '#ffa59e'
      },
      background: {
        "default": '#422016',
        hover: '#522112',
        active: '#68240f'
      }
    },
    help: {
      foreground: {
        "default": '#1a1a1a',
        hover: '#1a1a1a',
        active: '#1a1a1a'
      },
      base: {
        "default": '#2ac5e0',
        hover: '#40defa',
        active: '#8aefff'
      },
      background: {
        "default": '#142c30',
        hover: '#173e45',
        active: '#15474f'
      }
    },
    accent: {
      foreground: {
        "default": '#000000',
        hover: '#000000',
        active: '#000000'
      },
      base: {
        "default": '#ffffff',
        hover: '#f0f0f0',
        active: '#e0e0e0'
      },
      background: {
        "default": '#1a1a1a',
        hover: '#212121',
        active: '#292929'
      }
    },
    spotlight: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#1a1a1a',
        hover: 'rgba(26,26,26,0.8)',
        active: 'rgba(26,26,26,0.6)'
      },
      background: {
        "default": '#ffffff',
        hover: 'rgba(26,26,26,0.1)',
        active: 'rgba(26,26,26,0.2)'
      }
    },
    effects: {
      glasswall: 'rgba(26,26,26,0.7)',
      dropShadow: 'rgba(0,0,0,0.4)',
      highlight: {
        "default": 'rgba(2,74,216,0.1)',
        hover: 'rgba(0,54,196,0.3)',
        active: 'rgba(0,28,176,0.6)'
      }
    },
    focus: {
      "default": '#8fbaff',
      inverse: '#212121'
    }
  },
  highContrast: {
    foreground: {
      "default": '#ffffff',
      medium: '#ffffff',
      light: '#ffffff',
      disabled: '#adadad'
    },
    background: {
      "default": '#16141d',
      medium: '#16141d',
      container: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      disabled: '#525252'
    },
    stroke: {
      decorative: {
        "default": '#adadad',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      informative: {
        "default": '#adadad',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    effects: {
      glasswall: '#16141d',
      dropShadow: 'rgba(22,20,29,0)',
      highlight: {
        "default": 'rgba(22,20,29,0)',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    spotlight: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#ffffff',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    primary: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    neutral: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    positive: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#00d072',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    warning: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#ff8900',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    caution: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#ffe137',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    negative: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#ff6a4d',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    help: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#2ac5e0',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    accent: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    focus: {
      "default": '#00d3ff',
      inverse: '#16141d'
    }
  }
};
export var elevation = {
  level20: {
    offsetX: 0,
    offsetY: 5,
    blur: 20,
    spread: 5,
    boxShadow: '0px 5px 20px 5px'
  },
  glasswall: {
    offsetX: 0,
    offsetY: 0,
    blur: 16,
    spread: 0,
    boxShadow: '0px 0px 16px 0px'
  },
  level16: {
    offsetX: 0,
    offsetY: 4,
    blur: 16,
    spread: 4,
    boxShadow: '0px 4px 16px 4px'
  },
  level12: {
    offsetX: 0,
    offsetY: 3,
    blur: 12,
    spread: 3,
    boxShadow: '0px 3px 12px 3px'
  },
  level8: {
    offsetX: 0,
    offsetY: 2,
    blur: 8,
    spread: 2,
    boxShadow: '0px 2px 8px 2px'
  },
  level4: {
    offsetX: 0,
    offsetY: 1,
    blur: 4,
    spread: 1,
    boxShadow: '0px 1px 4px 1px'
  }
};
export var shape = {
  round: {
    borderRadius: 12
  },
  sharp: {
    borderRadius: 0
  },
  pill: {
    borderRadius: 12
  }
};
export var spacing = {
  standard: {
    borderRadius: {
      one: 12,
      two: 8,
      three: 16
    },
    padding: {
      one: 4,
      two: 8,
      three: 12,
      four: 16,
      five: 20,
      six: 24,
      seven: 28,
      eight: 32,
      intermediate: 12
    }
  },
  high: {
    borderRadius: {
      one: 8,
      two: 8,
      three: 12
    },
    padding: {
      one: 0,
      two: 4,
      three: 8,
      four: 12,
      five: 16,
      six: 20,
      seven: 24,
      eight: 28,
      intermediate: '6'
    }
  }
};
export var typography = {
  small: {
    titleLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '36px',
      weight: 500,
      lineHeight: '44px'
    },
    titleMedium: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '28px',
      weight: 500,
      lineHeight: '36px'
    },
    titleRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '24px',
      weight: 500,
      lineHeight: '32px'
    },
    titleSmall: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '20px',
      weight: 500,
      lineHeight: '28px'
    },
    subtitleLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '18px',
      weight: 500,
      lineHeight: '24px'
    },
    subtitleRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '16px',
      weight: 500,
      lineHeight: '20px'
    },
    overlineLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '16px',
      weight: 400,
      lineHeight: '20px'
    },
    overlineRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '12px',
      weight: 400,
      lineHeight: '16px'
    },
    bodyLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '16px',
      weight: 400,
      lineHeight: '24px'
    },
    bodyRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '14px',
      weight: 400,
      lineHeight: '24px'
    },
    labelRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '16px',
      weight: 400,
      lineHeight: '20px'
    },
    labelSmall: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '12px',
      weight: 400,
      lineHeight: '16px'
    },
    captionRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '14px',
      weight: 400,
      lineHeight: '20px'
    },
    captionSmall: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '12px',
      weight: 400,
      lineHeight: '16px'
    }
  },
  medium: {
    titleLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '56px',
      weight: 500,
      lineHeight: '64px'
    },
    titleMedium: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '40px',
      weight: 500,
      lineHeight: '48px'
    },
    titleRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '32px',
      weight: 500,
      lineHeight: '40px'
    },
    titleSmall: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '24px',
      weight: 500,
      lineHeight: '32px'
    },
    subtitleLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '20px',
      weight: 500,
      lineHeight: '28px'
    },
    subtitleRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '18px',
      weight: 500,
      lineHeight: '24px'
    },
    overlineLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '18px',
      weight: 400,
      lineHeight: '24px'
    },
    overlineRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '12px',
      weight: 400,
      lineHeight: '16px'
    },
    bodyLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '16px',
      weight: 400,
      lineHeight: '24px'
    },
    bodyRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '14px',
      weight: 400,
      lineHeight: '24px'
    },
    labelRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '16px',
      weight: 400,
      lineHeight: '20px'
    },
    labelSmall: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '12px',
      weight: 400,
      lineHeight: '16px'
    },
    captionRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '14px',
      weight: 400,
      lineHeight: '20px'
    },
    captionSmall: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '12px',
      weight: 400,
      lineHeight: '16px'
    }
  },
  large: {
    titleLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '72px',
      weight: 500,
      lineHeight: '84px'
    },
    titleMedium: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '56px',
      weight: 500,
      lineHeight: '64px'
    },
    titleRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '40px',
      weight: 500,
      lineHeight: '48px'
    },
    titleSmall: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '32px',
      weight: 500,
      lineHeight: '40px'
    },
    subtitleLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '24px',
      weight: 500,
      lineHeight: '32px'
    },
    subtitleRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '20px',
      weight: 500,
      lineHeight: '28px'
    },
    overlineLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '20px',
      weight: 400,
      lineHeight: '28px'
    },
    overlineRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '14px',
      weight: 400,
      lineHeight: '20px'
    },
    bodyLarge: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '18px',
      weight: 400,
      lineHeight: '24px'
    },
    bodyRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '16px',
      weight: 400,
      lineHeight: '24px'
    },
    labelRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '16px',
      weight: 400,
      lineHeight: '20px'
    },
    labelSmall: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '12px',
      weight: 400,
      lineHeight: '16px'
    },
    captionRegular: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '14px',
      weight: 400,
      lineHeight: '20px'
    },
    captionSmall: {
      family: "'Forma DJR UI', Arial, sans-serif",
      size: '12px',
      weight: 400,
      lineHeight: '16px'
    }
  }
};
var semantics = {
  breakpoint: breakpoint,
  color: color,
  elevation: elevation,
  shape: shape,
  spacing: spacing,
  typography: typography
};
export default semantics;